import { useRef, type ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { useScrollFade } from './useScrollFade'

/** Горизонтально прокручиваемая полоса без полосы прокрутки, с затуханием у того
 *  края, где ещё есть что прокрутить (`useScrollFade`) — иначе обрезанный пункт
 *  выглядел концом списка. */
export const ScrollFadeRow = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const fade = useScrollFade(ref)
  return (
    <div
      ref={ref}
      style={fade}
      className={cn(
        'overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
        className,
      )}
    >
      {children}
    </div>
  )
}
